import CategoryIcon from '@material-ui/icons/Bookmark';

import CategoryList from './CategoryList';

export default {
  list: CategoryList,
  icon: CategoryIcon,
};
